import { InjectionToken } from '@angular/core';

import type { RenderConfig } from '@konnexsion/markpress';

export const MARKPRESS_CONFIG = new InjectionToken<Partial<RenderConfig>>('MARKPRESS_CONFIG');
